import { LANGUAGE_CODE_ORDERED } from '@speeki/dictionary';

import i18n from '@services/TranslationsService/i18n';

import { currentLanguageVar } from '@boot/reactiveVariables';

interface DictionarySelect {
    key: string;
    label: string;
    value: string;
}

export interface DictionaryOptionalSelect {
    key?: string;
    label?: string;
    value?: string;
}

export const relationshipOptions = () => {
    const currentRelationship =
        i18n?.getDataByLanguage(i18n?.language)?.userRelationship || {};

    return Object.entries(currentRelationship)
        .filter((language) => language[0] !== 'ALL')
        .map((language) => ({
            key: language[0],
            label: i18n.t(language[0], {
                ns: 'userRelationship',
            }),
            value: language[0],
        }));
};

export const countriesOptions = () => {
    const currentCountries =
        i18n?.getDataByLanguage(i18n?.language)?.countries || {};

    return Object.entries(currentCountries)
        .filter((country) => country[0] !== 'ALL')
        .map((country) => ({
            key: country[0],
            label: i18n.t(country[0], { ns: 'countries' }),
            value: country[0],
        }));
};

export const languagesOptions = Object.entries(LANGUAGE_CODE_ORDERED).map(
    (language) => ({
        key: language[0],
        label: `${language[1].value} - ${language[1].meta}`,
        value: language[0],
    }),
);

const languagesEnglishOptions = Object.entries(LANGUAGE_CODE_ORDERED).map(
    (language) => ({
        key: language[0],
        label: language[1].value,
        value: language[0],
    }),
);

export const defaultSelectOption = (
    options: DictionarySelect[],
    value: unknown,
) => options.find((element) => element.value === value) || undefined;

export const currentLanguageSelect = () =>
    defaultSelectOption(languagesOptions, currentLanguageVar());

export const currentEnglishLanguageSelect = () =>
    defaultSelectOption(languagesEnglishOptions, currentLanguageVar());
